<template>
  <div>
    <vs-button @click="showLinks = !showLinks">Links anzeigen</vs-button>
    <h4 v-if="showLinks" class="bi-heading-button cursor-pointer mt-6">
      Links
    </h4>
    <table v-if="showLinks" class="important-informations">
      <thead>
        <tr>
          <th class="td-w-40">Name</th>
          <th class="td-w-40">Link</th>
          <th class="td-w-10">Einzigartige Klicks</th>
          <th class="td-w-10">Klicks</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="link of links" :key="link.id">
          <td class="td-w-40">{{ link.name }}</td>
          <td class="td-w-40">{{ link.link }}</td>
          <td class="td-w-10">{{ link.uniqueClicks.toLocaleString() }}</td>
          <td class="td-w-10">{{ link.totalClicks.toLocaleString() }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    links: { type: Array, required: true }
  },
  data() {
    return {
      showLinks: false
    };
  }
};
</script>
